import { render, staticRenderFns } from "./RadarPersonalReports.vue?vue&type=template&id=2545d06d&scoped=true"
import script from "./RadarPersonalReports.vue?vue&type=script&lang=js"
export * from "./RadarPersonalReports.vue?vue&type=script&lang=js"
import style0 from "./RadarPersonalReports.vue?vue&type=style&index=0&id=2545d06d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2545d06d",
  null
  
)

export default component.exports